import { Reducer } from 'redux';
import {
  ActionTypes,
  GET_COMPANIES_REQUEST, GET_COMPANIES_SUCCESS, GET_COMPANIES_FAILURE,
  GET_COMPANIES_LIST_REQUEST, GET_COMPANIES_LIST_SUCCESS, GET_COMPANIES_LIST_FAILURE,
  GET_COMPANY_REQUEST, GET_COMPANY_SUCCESS, GET_COMPANY_FAILURE,
  ADD_COMPANY_REQUEST, ADD_COMPANY_SUCCESS, ADD_COMPANY_FAILURE,
  EDIT_COMPANY_REQUEST, EDIT_COMPANY_SUCCESS, EDIT_COMPANY_FAILURE,
  DELETE_COMPANY_REQUEST, DELETE_COMPANY_SUCCESS, DELETE_COMPANY_FAILURE, SET_DELETE_COMPANY_POPUP
} from '../actions/companies.actions';


export interface Company {
  type: string;
  uuid: string;
  name: string;
  isActive?: boolean;
}

export interface CompaniesState {
  companies: Company[];
  totalCount: number;
  page: number;
}

export interface State {
  [x: string]: any;
  companies: { companies: Company[], totalCount: 0, page: 0 }
  companiesList: Company[],
  totalCount: number;
  page: number;
  company: Company | {};
  loading: boolean;
  error: string | null;
  addCompanyLoading: boolean;
  editCompanyLoading: boolean;
  deleteCompanyLoading: boolean;
  deletePopupOpen: boolean;
}

const initialState: State = {
  companies: { companies: [], totalCount: 0, page: 0 },
  companiesList:[],
  totalCount: 0,
  page: 1,
  company: {},
  loading: false,
  addCompanyLoading: false,
  editCompanyLoading: false,
  deleteCompanyLoading: false,
  error: null,
  deletePopupOpen: false,

};

const reducer: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMPANIES_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_COMPANIES_SUCCESS:
      const updatedCompanies = action.payload.page > 0
        ? state.companies.companies.concat(action.payload.companies)
        : action.payload.companies;
      return {
        ...state,
        companies: {
          companies: updatedCompanies,
          totalCount: action.payload.totalCount,
          page: action.payload.page,
        },
        loading: false,
        error: null,
      };
    case GET_COMPANIES_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };
      case GET_COMPANIES_LIST_REQUEST:
        return { ...state, loading: true, error: null };
      case GET_COMPANIES_LIST_SUCCESS:
        return {
          ...state,
          companiesList: action.payload.companies,
          loading: false,
          error: null,
        };
      case GET_COMPANIES_FAILURE:
        return { ...state, loading: false, error: action.payload };

    case GET_COMPANY_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_COMPANY_SUCCESS:
      return { ...state, team: action.payload, loading: false, error: null };
    case GET_COMPANY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case ADD_COMPANY_REQUEST:
      return { ...state, addCompanyLoading: true };
    case ADD_COMPANY_SUCCESS:
      return { ...state, addCompanyLoading: false };
    case ADD_COMPANY_FAILURE:
      return { ...state, addCompanyLoading: false };
    case EDIT_COMPANY_REQUEST:
      return { ...state, editCompanyLoading: true };
    case EDIT_COMPANY_SUCCESS:
      return { ...state, editCompanyLoading: false };
    case EDIT_COMPANY_FAILURE:
      return { ...state, editCompanyLoading: false };
    case DELETE_COMPANY_REQUEST:
      return { ...state, deleteCompanyLoading: true };
    case DELETE_COMPANY_SUCCESS:
      return { ...state, deleteCompanyLoading: false };
    case DELETE_COMPANY_FAILURE:
      return { ...state, deleteCompanyLoading: false };
    case SET_DELETE_COMPANY_POPUP:
      return { ...state, deletePopupOpen: action.payload };
    default:
      return state;
  }
};

export default reducer;
